/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text } from 'react-native'
import styles from './Styles/IconPostWallComponentStyle'
import { SvgLogoWall, SvgVideo, SvgDocument, SvgTilt } from './SvgComponent'
import { isSelling, isVideo, isLink } from '../Lib/utils'

export default class IconPostWallComponent extends Component {

  // checkType = (type) => {
  //   switch (type) {
  //     case '0':
  //       return
  //     case '1':
  //       return <SvgDocument size={10} />
  //     case '2':
  //       return (<View style={styles.direction}><SvgVideo size={10} /><SvgDocument size={10} /></View>)
  //     default:
  //       return
  //   }
  // }



  render() {
    const { data } = this.props
    return (
      <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
        {isSelling(data) && <View style={styles.marginRight}><SvgLogoWall size={10} /></View>}
        {isLink(data) && <View style={styles.marginRight}><SvgDocument size={10} /></View>}
      </View>
    )
  }
}
